module.exports = __webpack_public_path__ + "static/media/14.ea81e0e8.jpg";